import { Navigate } from 'react-router-dom';

import { ClientDashboard } from 'src/features/dashboard/ClientDashboard';
import { MEMBERSHIP_ROLES } from 'src/features/userManagement/types';
import { useParking } from 'src/providers/ParkingProvider';

type Permission = {
    hasPermission: boolean;
    redirectPath: string | Partial<Location>;
};
export type PermissionRedirect = {
    [key: string]: Permission;
};
export interface DashboardRedirectList {
    permissions: PermissionRedirect[];
}

const DashboardRedirect = ({ permissions }: DashboardRedirectList) => {
    const { parkingRole } = useParking();

    if (parkingRole === MEMBERSHIP_ROLES.CLIENT) {
        return <ClientDashboard />;
    }

    const firstAllowed = permissions.find((permission) => {
        const key = Object.keys(permission)[0];
        return permission[key].hasPermission;
    });

    if (firstAllowed) {
        const key = Object.keys(firstAllowed)[0];
        const { redirectPath } = firstAllowed[key];
        return <Navigate to={redirectPath} key={key} />;
    }

    return null;
};

export default DashboardRedirect;
